// src/ConsumerApp/Screens/ProductsList/components/MobileCategoryHeader.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import SlidersHorizontal from '../../../../assets/icons/SlidersHorizontal.svg';

export default function MobileCategoryHeader({
  categoryName = 'Products',
  totalCount = 0,
  appliedFiltersCount = 0,
  onOpenFilters,
}) {
  const navigate = useNavigate();

  return (
    <div className="bb-mob-cat-header-wrapper">
      <style>{`
        /* STRICTLY HIDDEN ON DESKTOP & TABLET (> 768px) */
        .bb-mob-cat-header-wrapper {
          display: none;
        }

        /* ONLY ACTIVE ON MOBILE (<= 768px) */
        @media (max-width: 768px) {
          .bb-mob-cat-header-wrapper {
            display: flex;
            flex-direction: column;
            width: 100%;
            background-color: #FFFFFF;
            position: sticky;
            top: 0;
            z-index: 100;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
          }

          /* Top Nav Row: Back, Category Name, Search */
          .bb-mob-cat-top-bar {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 52px;
            padding: 0 14px;
            border-bottom: 1px solid #F1F5F9;
          }

          .bb-mob-cat-left {
            display: flex;
            align-items: center;
            gap: 12px;
            min-width: 0;
          }

          .bb-mob-cat-back-btn {
            background: none;
            border: none;
            padding: 4px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #0F172A;
            border-radius: 8px;
            transition: background-color 0.15s ease;
          }

          .bb-mob-cat-back-btn:active {
            background-color: #F1F5F9;
          }

          .bb-mob-cat-title {
            font-size: 17px;
            font-weight: 800;
            color: #0F172A;
            margin: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            letter-spacing: -0.3px;
          }

          .bb-mob-cat-search-btn {
            background: none;
            border: none;
            padding: 6px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #1E293B;
            border-radius: 50%;
          }

          .bb-mob-cat-search-btn:active {
            background-color: #F1F5F9;
          }

          /* Sub-Bar: Total Items Count & Filter Button */
          .bb-mob-cat-sub-bar {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 44px;
            padding: 0 14px;
            background-color: #FFFFFF;
            border-bottom: 1px solid #E2E8F0;
          }

          .bb-mob-cat-count-text {
            font-size: 13px;
            font-weight: 600;
            color: #64748B;
          }

          .bb-mob-cat-filter-btn {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            background-color: #FFFFFF;
            border: 1px solid #CBD5E1;
            border-radius: 8px;
            padding: 5px 12px;
            font-size: 12.5px;
            font-weight: 700;
            color: #0F172A;
            cursor: pointer;
            position: relative;
            user-select: none;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
          }

          .bb-mob-cat-filter-btn:active {
            background-color: #F8FAFC;
          }

          .bb-mob-cat-filter-badge {
            background-color: #E9001E;
            color: #FFFFFF;
            font-size: 9.5px;
            font-weight: 800;
            border-radius: 999px;
            min-width: 16px;
            height: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 4px;
            line-height: 1;
          }
        }
      `}</style>

      {/* Row 1: Back + Category Title + Search SVG */}
      <div className="bb-mob-cat-top-bar">
        <div className="bb-mob-cat-left">
          <button
            type="button"
            className="bb-mob-cat-back-btn"
            onClick={() => navigate(-1)}
            aria-label="Go back"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <line x1="19" y1="12" x2="5" y2="12" />
              <polyline points="12 19 5 12 12 5" />
            </svg>
          </button>
          <h2 className="bb-mob-cat-title">{categoryName}</h2>
        </div>

        <button
          type="button"
          className="bb-mob-cat-search-btn"
          onClick={() => navigate('/consumer/search')}
          aria-label="Search"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
        </button>
      </div>

      {/* Row 2: Total Items Count + Filter Button */}
      <div className="bb-mob-cat-sub-bar">
        <span className="bb-mob-cat-count-text">
          {totalCount} {totalCount === 1 ? 'item' : 'items'}
        </span>

        <button
          type="button"
          className="bb-mob-cat-filter-btn"
          onClick={onOpenFilters}
        >
          <img
            src={SlidersHorizontal}
            alt="filters"
            style={{ width: 14, height: 14 }}
          />
          <span>Filters</span>
          {appliedFiltersCount > 0 && (
            <span className="bb-mob-cat-filter-badge">
              {appliedFiltersCount}
            </span>
          )}
        </button>
      </div>
    </div>
  );
}